// extracted by mini-css-extract-plugin
export default {"card":"StudyCard_card__E6U40"};